<template>
  <transition name="wipe-up">
    <div class="excluded-background" v-if="checkiOSApp && showOverlay">
        <div class="excluded-wrapper">
            <div class="intro">
                <h2>You didn’t select {{ publisher.name }}</h2>
                <p>&nbsp;</p>
                <p>Although we think you might see value in reading this article, it is from a source you chose not to read.</p>
                <p>&nbsp;</p>
                <p>Would you like to include {{ publisher.name }}?</p>
            </div>
            <div class="action">
                <div class="action-group">
                    <button v-on:click="didSelectRemovePublisher(publisher.code)" class="is-button no-arrow">Include {{ publisher.name }}</button>
                    <button v-on:click="didSelectCancel()" class="ghost-btn">Not now</button>
                </div>
            </div>
        </div>
    </div>
  </transition>
</template>

<script>
    import API from "app/axios.js";

    export default {
        data() {
            return {
                showOverlay: false,
                publisher: {},
                article: '',
                storySlug: ''
            }
        },
        mounted () {
            this.EventBus.$on("handleExcludedPublisher", (payload) => {
                this.showOverlay = true;
                this.publisher = payload.publisher;
                this.article = payload.article,
                this.storySlug = payload.storySlug
            });
        },
        computed: {
            checkiOSApp() {
                return this.$store.getters.hasIOSApp;
            }
        },
        methods: {
            deviceMessage(sMode, oData){
                this.EventBus.$emit("appCallback", {
                    type: sMode,
                data: oData || {}
            });
            },
            
            deviceLog(sMessage){
                this.deviceMessage('consoleXCode',{
                    message: sMessage,
                });
            },

            fetchPublishers() {
                return this.$store.getters.getPublishers;
            },

            didSelectRemovePublisher(code) {
                const excluded = this.$store.getters.getExcludedPublishers;
                excluded.splice(excluded.indexOf(code), 1)
                if (this.isLoggedIn) {
                    API.patchExcludedPublishers(excluded);
                    this.$store.commit('updateExcludedPublishers', excluded);
                } else {
                    localStorage.setItem('excluded_publishers', JSON.stringify(excluded));
                    this.$store.commit('updateExcludedPublishers', excluded);
                }
                this.showOverlay = false;
                this.EventBus.$emit('didAddExcludedPublisher', {
                    article: this.article,
                    storySlug: this.storySlug
                });
            },

            didSelectCancel() {
                this.showOverlay = false;
                this.$router.back();
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import "~styles/_variables";

    .wipe-up-enter-active {
        transition: all .3s ease;
    }

    .wipe-up-leave-active{
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .wipe-up-enter, .wipe-up-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */ {
        transform: translateY(100vh);
        opacity: 0;
    }

    .excluded-background {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 600;
        background: $background-faded;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .excluded-wrapper {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        background: $base-primary;
        padding: 20px;
        z-index: 700;

        h2, p {
            color: $white-primary;
            margin-top: 0;
        }

        .intro {
            display: flex;
            flex-direction: column;
            text-align: center;

            h2 {
                font-weight: bold;
                font-size: 22px;
            }

            p {
                font-size: 15px;
                line-height: 1.4;
                margin-bottom: 0;

                &.bold {
                    font-weight: bold;
                }
            }
        }

        .action {
            display: flex;
            justify-content: center;
            margin-top: 20px;
            margin-bottom: 10px;
            width: 100%;

            .action-group {
                display: flex;
                flex-direction: column;
                width: 100%;

                .ghost-btn {
                    color: $white-primary-faded;
                    font-weight: bold;
                    font-size: 12px;
                    margin-top: 15px;
                    text-decoration: none;
                    border: none;
                    outline: none;
                    background: transparent;
                }
            }
        }

        .is-button {
            width: 100%;
            padding: 1.2em;
        }
    }
</style>